(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());

var formatMoney = "$ \{\{amount\}\}";

var isiOS = false;
var agent = navigator.userAgent.toLowerCase();
if(agent.indexOf('iphone') >= 0 || agent.indexOf('ipad') >= 0){
	isiOS = true;
}

jQuery(function($) {
  	if(!isiOS) {
		$('body').addClass('no-touch');
  	}

  	$('.quantity').each(function(){
      	var wrapper = $(this);
		wrapper.find('.minus').click(function(){ 
          	try {
              wrapper.find('#quantity').get(0).stepDown();
            } catch(e) {
              var value = (parseInt(wrapper.find('#quantity').val())-1);
              wrapper.find('#quantity').val((value>=1 ? value : 1));
            }
        });
        wrapper.find('.plus').click(function(){
          try {
          	wrapper.find('#quantity').get(0).stepUp();
          } catch(e) {
          	wrapper.find('#quantity').val((parseInt(wrapper.find('#quantity').val())+1));
          }
        });  
  	});	

  	if($('#mini-cart').length > 0) {
    	initMiniCart();
  	}
  
  	
  		$('body').delegate('.add-to-cart-form', 'submit', function(){
            if(validateAddCart($(this))) {
              addToCart($(this));
            }
            return false;
        });
  	
  
  	$(window).scroll(function(){
        if($(this).scrollTop()<=200) {
          $('.scrollup').fadeOut();
        } else {
          $('.scrollup').fadeIn();
        }
    });
});

function validateAddCart(form) {
  	if(form.find('input[name=id]').val()=='') {
        var allOptionsSelected;
      	if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
          	allOptionsSelected = false;
        }
      	
      	if(allOptionsSelected) {
          	var errorMsg = form.find('.validation-msg').text();
          	if(errorMsg) {
          		$.fancybox('<div class="validation-msg">'+errorMsg+'</div>');
            } else {
              	$.fancybox('<div class="validation-msg">The selected variant is sold out.</div>');
            }
        } else {
        	var labels = [];
            form.find('.options label').each(function(key, obj){
                labels.push($.trim($(obj).text().replace(':', '')));
            });
          	$.fancybox('<div class="validation-msg">You must select a '+labels.join('/')+'.</div>');
        }
      	return false;
    }

  	var ok = true;
  	form.find('.required').each(function(){
      	if($(this).val()=='') {
          	var labels = [];
            form.find('.options.properties label').each(function(key, obj){
              	if($(this).next().hasClass('required')) {
                	labels.push($.trim($(obj).text().replace(':', '')));
                }
            });

          	$.fancybox('<div class="validation-msg">You must enter '+labels.join('/')+'.</div>');
          	ok = false;
          	return false;
      	}
    });
  
  	return ok;
}

function initMiniCart() {
	$('#view-cart-normal').click(function(e){
      e.stopPropagation();
      $('#mini-cart').slideToggle();
      return false;
    });

    $(document).click(function(){
      $("#mini-cart").slideUp();
    });

    $('body').delegate('#mini-cart a.remove-from-cart', 'click', function(){
      var variantId = $(this).attr('href').replace('#', '');
      
      
      	removeItemToCart(variantId);
      
      
      return false;
    });
}

/**
 * Page-specific call-backs
 * Called after dom has loaded.
 */
var RADIANCE = {

	common : {
		init: function(){
			$('html').removeClass('no-js').addClass('js');
			setupDropdownMenus();

			$('.nav-arrow', '#top-menu').each( function(){
				$(this).css('top', Math.ceil($(this).parent(2).height()/2) + 1);
			});

		}
	},

	templateIndex : {
		init: function(){

		}
	},

	templateProduct : {
		init: function(){
			//$('#product-actions').bind( 'submit', addToCart );
			$('#thumbs li:nth-child(5n+5)').addClass('last-in-row');
		}
	},

	templateCart : {
		init: function(){
          var checkGiftNote = function() {
              if($('#chk-is-gift').is(':checked')) {
                  $('#is-gift').val('Yes');
                	$('#gift-note').show();
              } else {
                  $('#is-gift').val('No');
                  $('#gift-note').hide();
                  $('#gift-note').find('textarea').val("");
              }
          }
          $('#chk-is-gift').click(function(){
            	checkGiftNote();
          });
          checkGiftNote();
		}
	}

}

/**
 * Fire function based upon attributes on the body tag.
 * This is the reason for "template" in layout/theme.liquid
 *
 * @see http://paulirish.com/2009/markup-based-unobtrusive-comprehensive-dom-ready-execution/
 */
var UTIL = {

	fire : function(func,funcname, args){
		var namespace = RADIANCE;
		funcname = (funcname === undefined) ? 'init' : funcname;
		if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function'){
			namespace[func][funcname](args);
		}
	},

	loadEvents : function(){
		var bodyId = document.body.id;

		// hit up common first.
		UTIL.fire('common');

		// do all the classes too.
		$.each(document.body.className.split(/\s+/),function(i,classnm){
			UTIL.fire(classnm);
			UTIL.fire(classnm,bodyId);
		});
	}

};
$(document).ready(UTIL.loadEvents);

/**
 * Support for dropdown menus
 */
function setupDropdownMenus(){
	$('#menu-container .has-dropdown').hoverIntent( navRollOver, navRollOut );

	function navRollOver(e){
		$(this).addClass('active').find('ul:first').css('top', $(this).height()).show();
	}
	function navRollOut(e){
		$(this).removeClass('active').find('ul:first').hide();
	}
}

/**
 * Ajaxy add-to-cart
 */
function addToCart(form){
  	$('#add-cart-overlay').fadeIn();

	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
      	cache: false,
		data: form.serialize(),
		dataType: 'json',
		error: addToCartFail,
		success: addToCartSuccess,
		cache: false
	});
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){
  	$.ajax({
		type: 'GET',
		url: '/cart.js',
		//async: false,
		cache: false,
		dataType: 'json',
		success: updateCartDesc
	});
	$('#add-cart-overlay').fadeOut();
  
  	$.fancybox($("<div />").append($("#item-added").clone().show()).html(), {
    	'overlayOpacity' : 0.6,
        'overlayColor' : '#000',
        onClosed: function(){
          	
        }
    });
  	setTimeout(function(){
    	$.fancybox.close();
    }, 2000);
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  	var response = $.parseJSON(jqXHR.responseText);
	$('#add-to-cart-msg').addClass('error').text(response.description).fadeIn('fast');
  	$('#add-cart-overlay').fadeOut();
  
  	var popup = $("#item-added").clone().addClass('error').show();
  	popup.find('.buttons').hide();
  	popup.find('.msg').html('- '+ response.description +' -');
  	$.fancybox($("<div />").append(popup).html(), {
    	'overlayOpacity' : 0.6,
        'overlayColor' : '#000',
    });
}

function removeItemToCart(variantId){
  	$('#add-cart-overlay').fadeIn();

	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
      	data: {
          id: variantId,
          quantity: 0
        },
		dataType: 'json',
      	error: function(){
      		$('#add-cart-overlay').fadeOut();
      	},
      	success: function(){
          	updateCartDesc();
      		$('#add-cart-overlay').fadeOut();
      	},
		cache: false
	});
}

function updateCartDesc(){  
  	$.ajax({
		type: 'GET',
		url: '/pages/mini-cart',
		async: false,
		cache: false,
      	success: function(data){
      		$('#mini-cart').remove();
          	$('li.cart-normal').append(data);
      	}
	});
}